import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { getPartnersBrandConfig } from '@tk/app/partners-branding';

@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    const partner = getPartnersBrandConfig().title;
    if (title !== undefined) {
      this.title.setTitle(`${title} – ${partner}`);
    } else {
      this.title.setTitle(partner);
    }
  }
}
